/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

function registerBackInStock() {
  const bisTrigger = document.querySelector('.bis-trigger');
  const bisWrapper = document.querySelector('.bis-popup-wrapper');
  const productTitle = document.querySelector('.product__head .product__title');
  const bisBackdrop = document.querySelector('.bis-backdrop:not(.main-product)');

  if (bisBackdrop != null) {
    bisBackdrop.addEventListener('click', function () {
      bisWrapper.classList.remove('visible');
      document.querySelector('.bis-popup__success').classList.remove('visible');
    });
  }

  if (bisWrapper != null) {
    bisWrapper.addEventListener('click', function (e) {
      let isInPopup = false;

      if (e.path) {
        e.path.forEach(p => {
          if (p.className && p.className.includes('bis-popup-modal')) {
            isInPopup = true;
          }
        })

        if (!isInPopup) {
          bisWrapper.classList.remove('visible');  
        }
      }
    });
  }

  if (bisTrigger != null) {
    bisTrigger.addEventListener('click', function () {
      if (productTitle) {
        document.querySelector('.bis-popup__title.product__title').innerHTML = productTitle.innerHTML;  
      }
      bisWrapper.classList.add('visible');
    });
  }

  const bisCloseTrigger = document.querySelector('.bis-popup__close:not(.main-product)');

  if (bisCloseTrigger != null) {
    bisCloseTrigger.addEventListener('click', function () { 
      bisWrapper.classList.remove('visible');
      document.querySelector('.bis-popup__success').classList.remove('visible');
    });
  }
  
  const bisSignupTrigger = document.querySelector('.bis-signup-trigger:not(.main-product)');

  if (bisSignupTrigger != null) {
    bisSignupTrigger.addEventListener('click', function () {
      const errorField = document.querySelector('.bis-popup__error');
      errorField.innerHTML = "";

      const email = document.querySelector('.bis-popup input[type="email"]')?.value;
      const productId = document.querySelector('.template-product-page').getAttribute('data-product-id');
      const variantId = document.querySelector('.template-product-page').getAttribute('data-variant-id');
      const subscribeToNewsletter = document.querySelector('.bis-popup #subscribe_for_newsletter').checked;

      if (email == null || !email.includes('@')) {
        errorField.innerHTML = "Email skal være fyldt ud med en valid email addresse";
        return;
      }

      const data = {
        a: "RevDxj",
        email: email,
        variant: variantId,
        product: productId,
        platform: "shopify",
        subscribe_for_newsletter: subscribeToNewsletter,
        g: "Sj3yqd"
      };

      fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        method: 'POST',
        headers: {
          'accept': 'application/json, text/plain, */*',
          'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: new URLSearchParams((data))
      }).then((response) => {
        const content = response.json();
        document.querySelector('.bis-popup__success').classList.add('visible');
      }).catch(error => {
        console.log(error);
        errorField.innerHTML = "Vi kunne desværre ikke registere dig. Prøv igen om lidt.";
        // TODO: Handle error 
      })
    });
  }
}

function checkPreorder() {
  const preorderInfoDrawer = document.querySelector(".cart__foot .preorder-info");
  const preorderInfoCartPage = document.querySelector("div.cart__aside > div.preorder-info");

  preorderInfoDrawer?.classList.add("hidden");
  preorderInfoCartPage?.classList.add("hidden");
 
  const cartItems = document.querySelectorAll(".cart__item");
  if (cartItems.length === 0) return;

  let preorderShippingDate = "";
  cartItems.forEach(function(item) {
    if (item.hasAttribute("data-preorder-item")) {
      preorderInfoDrawer?.classList.remove("hidden");
      preorderInfoCartPage?.classList.remove("hidden");
      itemShippingDate = item.getAttribute("data-preorder-shipping-date");
      if (preorderShippingDate == "" || itemShippingDate > preorderShippingDate) {
        preorderShippingDate = itemShippingDate;
      }
    }
  });

  if (preorderShippingDate != "") {
    const date = new Date(preorderShippingDate);
    options = { day: '2-digit', month: '2-digit', year: 'numeric'}
    const formattedDate = date.toLocaleDateString('da-DK', options);
    document.querySelector(".cart__foot .preorder-shipping-date").innerHTML = formattedDate;
  }
}

async function loadAllProducts() {
  const templateSuffix = "json-bb";
  const collectionHandle = "all";
  const urlPrefix = window.theme.routes.root;

  if (urlPrefix !== "/") urlPrefix += "/";

  const response = await fetch(
    `${urlPrefix}collections/${collectionHandle}?view=${templateSuffix}`,
    {
      type: "GET",
    }
  );

  const json = await response.json();
  window.ALL_PRODUCTS = json.products;
}

(async function() {
  // Add custom code below this line
  registerBackInStock();
  checkPreorder();
  await loadAllProducts();

  document.addEventListener('theme:product:added', function (event) {
    checkPreorder();
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}} kr";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.duvets = [];
    this.duvetsSameColor = [];
    this.pillowcases = [];
    this.pillowcasesSameColor = [];
    this.productColor = this.dataset.productColor;
    this.sameProductCollection = this.dataset.sameProductCollection;

    this.selected = {
      duvet: null,
      pillowcase: null
    }

    this.priceNode = this.querySelector('.product__price span[data-product-price]');
  }

  connectedCallback() {
    const promises = [loadAllProducts()];

    Promise.all(promises).then(() => { 
      this.renderDuvets();
      this.renderPillowcases();
      this.initElements();
      this.registerEvents();
      this.handleUpdate();

      const preselectedDuvet = this.duvetsSameColor.find(p => p.handle == window.location.pathname.split("/products/")[1]);
      const preselectedDuvetNode = this.querySelector(`.product__selectors-duvet .select-popout__list li[data-size="${preselectedDuvet?.size} cm"]`);
      const firstPillow60x63 = this.querySelector('.product__selectors-pillow .select-popout__list li[data-size="60x63 cm"]');
      const firstDuvet = this.querySelector('.product__selectors-duvet .select-popout__list li');
      const firstPillow = this.querySelector('.product__selectors-pillow .select-popout__list li');

      if (preselectedDuvetNode) {
        this.handleDuvetClick(preselectedDuvetNode, this.querySelector('.product__selectors-duvet .selector-wrapper-size'));
      } else if (firstDuvet) {
        this.handleDuvetClick(firstDuvet, this.querySelector('.product__selectors-duvet .selector-wrapper-size'));
      }

      if (firstPillow60x63) {
        this.handlePillowClick(firstPillow60x63, this.querySelector('.product__selectors-pillow .selector-wrapper-size'));
      } else if (firstPillow) {
        this.handlePillowClick(firstPillow, this.querySelector('.product__selectors-pillow .selector-wrapper-size'));
      }

      this.cartBarTitle = document.querySelector('.cart-bar .cart-bar__product__title');
      this.cartBarTitle.innerHTML = this.querySelector('.product__title').innerHTML;
    });
  }

  renderDuvets() { 
    this.duvets = window.ALL_PRODUCTS.filter(p => p.type.includes('Duvet') && p.tags.includes('Bundle_Product') && p.same_product_collection == this.sameProductCollection);
    this.duvetsSameColor = this.duvets.filter(_ => _.color == this.productColor)

    const sortedDuvetArray = this.duvetsSameColor.sort((a, b) => {
      const sizeA = a.size.split('x').map(Number);
      const sizeB = b.size.split('x').map(Number);
    
      for (let i = 0; i < sizeA.length; i++) {
        if (sizeA[i] !== sizeB[i]) {
          return sizeA[i] - sizeB[i];
        }
      }
    
      return 0; // Sizes are the same
    });
    
    const sizeWrapper = this.querySelector('.product__selectors-duvet .selector-wrapper-size');
    const popupList = sizeWrapper.querySelector('.select-popout__list');
    const duvetTemplate = this.querySelector('.select-popout__list-template > li');

    popupList.innerHTML = '';

    for (let index = 0; index < sortedDuvetArray.length; index++) {
      const duvet = this.duvetsSameColor[index];
      const node = duvetTemplate.cloneNode(true);
      const label = node.querySelector('.select-popout__option-label');
      const price = node.querySelector('.select-popout__option-price');
      const backInStock = node.querySelector('.select-popout__option-bis');
      const preorder = node.querySelector('.select-popout__option-preorder');
      const initialVariantId = node.getAttribute('data-value');

      backInStock.classList.add('hidden');
      price.classList.remove('hidden');

      const size = duvet.size.split(' / ')[0] + " cm";
      label.innerHTML = size;
      price.innerHTML = duvet.price_money;

      if (duvet.inStock == 0 && duvet.isPreorder == "true" && duvet.inventoryPolicy == 'continue') {
        preorder.classList.remove('hidden');
      }
      else if (duvet.inStock == 0) {
        backInStock.classList.remove('hidden');
        price.classList.add('hidden');
        node.classList.add('out-of-stock');
      }

      node.setAttribute('data-value', duvet.id);
      node.setAttribute('data-id', duvet.id);
      node.setAttribute('data-size', size);
      node.setAttribute('data-type', 'Dynebetræk');

      // if ((initialVariantId == duvet.id || (this.selected.duvet && this.selected.duvet.id == duvet.id))) {
      //   if (duvet.inStock > 0) {
      //     node.classList.add('is-active');
      //     this.selected.duvet = duvet;  
      //   } else {
      //   }
      // }
      
      popupList.appendChild(node);
    }

    const options = sizeWrapper.querySelectorAll('.select-popout__list li');
    const optionDropdown = sizeWrapper.querySelector('.select-popout__toggle');
    options.forEach((option) => {
      option.addEventListener('click', (evt) => {
        const target = evt.currentTarget;
        this.handleDuvetClick(target, sizeWrapper);
        optionDropdown.ariaExpanded = false;
        const visiblePoputList = document.querySelector('.select-popout__list.popout-list--visible')
        if(visiblePoputList) visiblePoputList.classList.remove('popout-list--visible');
      });
    });
  }

  handleDuvetClick(target, sizeWrapper) {
    const id = target.getAttribute('data-id');
    const variantSize = target.getAttribute('data-size');

    if (target.classList.contains('out-of-stock')) {
      return;
    }

    const sizeSelectorText = sizeWrapper.querySelector('.select-popout__toggle > span[data-popout-toggle-text]');
    sizeSelectorText.innerHTML = "<span class='popout-inside-label'>Dynebetræk:</span>" + variantSize;

    target.parentElement.querySelectorAll('li').forEach((li) => li.classList.remove('is-active'));
    target.classList.add('is-active');
    this.selected.duvet = this.duvets.find(p => p.id == id);

    const quantityWrapper = sizeWrapper.closest('.product__selectors').querySelector('.selector-wrapper--quantity')
    if (quantityWrapper.classList.contains('hidden')) {
      quantityWrapper.querySelector('input').value = 1;
      quantityWrapper.classList.remove('hidden');  
    }

    const swatches = this.querySelectorAll('.main-product__form-color .list-swatches > li');
    swatches.forEach((swatch) => {
      const swatchColor = swatch.getAttribute('data-color');

      if (!swatchColor) {
        return;
      }

      const duvet = this.duvets.find(d => d.size && d.size.toString().includes(variantSize.replace(' cm', '')) && d.color == swatchColor);

      if (duvet) { 
        swatch.setAttribute('data-product-url', duvet.url);
        const swatchBtnWrapper = swatch.querySelector('.swatch-btn-wrapper');

        if (duvet.inStock == 0 && duvet.isPreorder == "true" && duvet.inventoryPolicy == 'continue') {
          swatchBtnWrapper.classList.remove('swatch-sold-out');
        }
        else if (duvet.inStock == 0) {
          swatchBtnWrapper.classList.add('swatch-sold-out');
        }
        else {
          swatchBtnWrapper.classList.remove('swatch-sold-out');
        }
      }
    });

    const inventoryJSON = document.querySelector('script[data-product-remaining-json]').textContent;
    const inventoryData = JSON.parse(inventoryJSON);

    // Getting the inventory count for the selected variant ID
    const inventoryCount = inventoryData[id];

    // Accessing the translated string for inventory count from the window object
    // and replacing the placeholder with the actual inventory count
    const remainingInventoryString = window.translationStrings.remainingInventory.replace('{{ inventory }}', inventoryCount);

    // Selecting the element that displays the inventory count and updating its text content
    const inventoryDisplayElement = document.querySelector('.variant__countdown__low');
    if (inventoryDisplayElement) {
      inventoryDisplayElement.textContent = remainingInventoryString;
    }
    
    this.handleUpdate();
    window.history.pushState(null, '', window.location.origin + "/products/" + this.selected.duvet.handle);
  }

  renderPillowcases() { 
    this.pillowcases = window.ALL_PRODUCTS.filter(p => p.type.includes('Pillowcase') && p.tags.includes('Bundle_Product'));
    this.pillowcasesSameColor = this.pillowcases.filter(p => p.color == this.productColor);

    const sizeWrapper = this.querySelector('.product__selectors-pillow .selector-wrapper-size');
    const popupList = sizeWrapper.querySelector('.select-popout__list');
    const pillowcaseTemplate = this.querySelector('.select-popout__list-template > li');

    popupList.innerHTML = '';

     for (let index = 0; index < this.pillowcasesSameColor.length; index++) {
      const pillowcase = this.pillowcasesSameColor[index];
      const node = pillowcaseTemplate.cloneNode(true);
      const label = node.querySelector('.select-popout__option-label');
      const price = node.querySelector('.select-popout__option-price');
      const backInStock = node.querySelector('.select-popout__option-bis');
      const preorder = node.querySelector('.select-popout__option-preorder');
       
      label.innerHTML = pillowcase.size;
      price.innerHTML = pillowcase.price_money;
      
      if (pillowcase.inStock == 0 && pillowcase.isPreorder == "true" && pillowcase.inventoryPolicy == 'continue') {
        preorder.classList.remove('hidden');
      }
      else if (pillowcase.inStock == 0) {
        backInStock.classList.remove('hidden');
        price.classList.add('hidden');
        node.classList.add('out-of-stock');
      }

      node.setAttribute('data-value', pillowcase.id);
      node.setAttribute('data-id', pillowcase.id);
      node.setAttribute('data-size', pillowcase.size);
      node.setAttribute('data-type', 'Pudebetræk');
      popupList.appendChild(node);
    }

    const options = sizeWrapper.querySelectorAll('.select-popout__list li');
    const optionDropdown = sizeWrapper.querySelector('.select-popout__toggle');
    options.forEach((option) => {
      option.addEventListener('click', (evt) => {
        const target = evt.currentTarget;
        this.handlePillowClick(target, sizeWrapper);
        optionDropdown.ariaExpanded = false;
        const visiblePoputList = document.querySelector('.select-popout__list.popout-list--visible')
        if(visiblePoputList) visiblePoputList.classList.remove('popout-list--visible');
      });
    });
  }

  handlePillowClick(target, sizeWrapper) {
    const id = target.getAttribute('data-id');
    const variantSize = target.getAttribute('data-size');

    if (target.classList.contains('out-of-stock')) {
      return;
    }

    const sizeSelectorText = sizeWrapper.querySelector('.select-popout__toggle > span[data-popout-toggle-text]');
    sizeSelectorText.innerHTML = "<span class='popout-inside-label'>Pudebetræk:</span>" + variantSize;

    target.parentElement.querySelectorAll('li').forEach((li) => li.classList.remove('is-active'));
    target.classList.add('is-active');
    this.selected.pillowcase = this.pillowcasesSameColor.find(p => p.id == id);

    const quantityWrapper = sizeWrapper.closest('.product__selectors').querySelector('.selector-wrapper--quantity')
    if (quantityWrapper.classList.contains('hidden')) {
      quantityWrapper.querySelector('input').value = 1;
      quantityWrapper.classList.remove('hidden');  
    }

    this.handleUpdate();
  }

  initElements() {
    const duvetQuantity = this.querySelector('.product__selectors-duvet .selector-wrapper--quantity');
    const pillowQuantity = this.querySelector('.product__selectors-pillow .selector-wrapper--quantity');
    const duvetCounter = new QuantityCounter(duvetQuantity);
    duvetCounter.init();

    const pillowCounter = new QuantityCounter(pillowQuantity);
    pillowCounter.init();
  }

  handleCartButtonClick(evt) {
    evt.preventDefault();
    const target = evt.currentTarget;

    const duvetId = this.selected.duvet?.id;
    const pillowcaseId = this.selected.pillowcase?.id;
    const duvetQuantity = this.querySelector('.product__selectors-duvet .selector-wrapper--quantity input')?.value;
    const pillowQuantity = this.querySelector('.product__selectors-pillow .selector-wrapper--quantity input')?.value;

    const data = {
      items: []
    };

    if (duvetId && duvetQuantity && duvetQuantity > 0) {
      const lineDuvet = {
        id: duvetId,
        quantity: Number(duvetQuantity),
      };

      data.items.push(lineDuvet);
    }

    if (pillowcaseId && pillowQuantity && pillowQuantity > 0) {
      const linePillow = {
        id: pillowcaseId,
        quantity: Number(pillowQuantity),
      };

      data.items.push(linePillow);
    }

    if (data.items.length == 0) {
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      const content = response.json();

      target.dispatchEvent(
        new CustomEvent('theme:product:add', {
          detail: {
            response: response,
            button: target,
            refreshCart: true
          },
          bubbles: true,
        })
      );
    }).catch(error => {
      console.log(error);
    });
  }

  handleCartBarButtonClick(evt) {
    evt.preventDefault();
    this.querySelector('.product__submit__add')?.click();
  }

  handleQuantityMinusClick(evt) {
    const target = evt.currentTarget;
    const input = target.parentElement.querySelector('input');
    const value = Number(input.value);
    if (value == 0) {
      target.closest('.selector-wrapper--quantity').classList.add('hidden');

      const productSelectorsDuvet = target.closest('.product__selectors-duvet');
      const productSelectorsPillow = target.closest('.product__selectors-pillow');

      if (productSelectorsDuvet) {
        this.selected.duvet = null;
        productSelectorsDuvet.querySelectorAll('li').forEach((li) => li.classList.remove('is-active'));
        productSelectorsDuvet.querySelector('span[data-popout-toggle-text]').innerHTML = "Vælg dynebetræk størrelse";
      }

      if (productSelectorsPillow) {
        this.selected.pillowcase = null;
        productSelectorsPillow.querySelectorAll('li').forEach((li) => li.classList.remove('is-active'));
        productSelectorsPillow.querySelector('span[data-popout-toggle-text]').innerHTML = "Vælg pudebetræk størrelse";
      }
    }

    this.handleUpdate();
  }

  handleQuantityPlusClick(evt) {
    this.handleUpdate();
  }

  handleBackInStockClick(evt) {
    const target = evt.currentTarget;
    const selectPopoutItem = target.closest('.select-popout__item');
    const variantId = selectPopoutItem.getAttribute('data-id');
    const variantSize = selectPopoutItem.getAttribute('data-size');
    const variantType = selectPopoutItem.getAttribute('data-type');
    const variantColor = this.productColor;
    const title = `${variantType} (${variantSize}) - ${variantColor}`;

    const bisPopup = document.querySelector('.bis-popup-wrapper');
    bisPopup.classList.add('visible');

    const bisPopupTitle = bisPopup.querySelector('.bis-popup__title');
    bisPopupTitle.innerHTML = title;

    const bisSignupTrigger = document.querySelector('.bis-signup-trigger');
    let clickEvent;

    if (bisSignupTrigger != null) {
      clickEvent = signup.bind();
      bisSignupTrigger.addEventListener('click', clickEvent);
    }

    const bisCloseTrigger = document.querySelector('.bis-popup__close');

    if (bisCloseTrigger != null) {
      bisCloseTrigger.addEventListener('click', closePopup.bind());
    }

    const bisBackdrop = document.querySelector('.bis-backdrop');

    if (bisBackdrop != null) {
      bisBackdrop.addEventListener('click', closePopup.bind());
    }

    function closePopup() {
      bisPopup.classList.remove('visible');
      document.querySelector('.bis-popup__success').classList.remove('visible');

      if (bisSignupTrigger != null) {
        bisSignupTrigger.removeEventListener('click', clickEvent);
      }
    }

    function signup() {
      const errorField = document.querySelector('.bis-popup__error');
      errorField.innerHTML = "";

      const email = document.querySelector('.bis-popup input[type="email"]')?.value;
      const productId = document.querySelector('.template-product-page').getAttribute('data-product-id');
      const subscribeToNewsletter = document.querySelector('.bis-popup #subscribe_for_newsletter').checked;

      if (email == null || !email.includes('@')) {
        errorField.innerHTML = "Email skal være fyldt ud med en valid email addresse";
        return;
      }

      const data = {
        a: "RevDxj",
        email: email,
        variant: variantId,
        product: productId,
        platform: "shopify",
        subscribe_for_newsletter: subscribeToNewsletter,
        g: "Sj3yqd"
      };

      fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
        method: 'POST',
        headers: {
          'accept': 'application/json, text/plain, */*',
          'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: new URLSearchParams((data))
      }).then((response) => {
        const content = response.json();
        document.querySelector('.bis-popup__success').classList.add('visible');
      }).catch(error => {
        console.log(error);
        errorField.innerHTML = "Vi kunne desværre ikke registere dig. Prøv igen om lidt.";
        // TODO: Handle error 
      })
    }
  }

  handleColorSwatchClick(evt) {
    const target = evt.currentTarget;
    const productId = target.dataset.productId;
    const productUrl = target.dataset.productUrl;
    const color = target.dataset.color;

    this.querySelector('.main-product__form-sublabel').innerHTML = color;
    document.querySelector('.template-product-page').setAttribute('data-product-id', productId);
    this.querySelectorAll('.list-swatches > li').forEach((swatch) => swatch.classList.remove('active'));
    this.querySelector(`.list-swatches > li[data-color="${color}"]`).classList.add('active');

    const sectionId = this.closest(".shopify-section").id.split("shopify-section-")[1];
    const fetchVariantURL = `${productUrl}?section_id=${sectionId}`;

    fetch(fetchVariantURL)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");

        window.history.pushState({}, "", productUrl);

         // Title
        this.replaceHtml(doc, ".product__title");

        // // Price
        // this.replaceHtml(doc, ".product__price__wrap");

        // Images
        this.replaceHtml(doc, ".product__images");   
        this.replaceHtml(doc, ".product-upsell__holder");
        this.replaceHtml(doc, ".product__button__meta");

        this.productColor = color;
        if (this.cartBarTitle) {
          this.cartBarTitle.innerHTML = this.querySelector('.product__title').innerHTML;  
        }

        if (this.selected.duvet) {
          const duvet = this.duvets.find(p => p.size == this.selected.duvet.size && p.color == color && (p.inStock > 0 || p.isPreorder == "true"));
          if (duvet) {
            this.selected.duvet = duvet;
          }
          else {
            this.selected.duvet = null;
            this.querySelector('.product__selectors-duvet span[data-popout-toggle-text]').innerHTML = "Vælg dynebetræk størrelse";
            const duvetQuantity = this.querySelector('.product__selectors-duvet .selector-wrapper--quantity');
            duvetQuantity.classList.add('hidden');
            duvetQuantity.querySelector('input').value = 0;
          }
        }

        if (this.selected.pillowcase) {
          const pillowcase = this.pillowcases.find(p => p.size == this.selected.pillowcase.size && p.color == color && (p.inStock > 0 || p.isPreorder == "true"));
          if (pillowcase) {
            this.selected.pillowcase = pillowcase;
          }
          else {
            this.selected.pillowcase = null;
            this.querySelector('.product__selectors-pillow span[data-popout-toggle-text]').innerHTML = "Vælg pudebetræk størrelse";
            const pillowQuantity = this.querySelector('.product__selectors-pillow .selector-wrapper--quantity');
            pillowQuantity.classList.add('hidden');
            pillowQuantity.querySelector('input').value = 0;
          }
        }

        this.renderDuvets();
        this.renderPillowcases();
        this.handleUpdate();

        this.querySelectorAll('.select-popout__list li .select-popout__option-bis').forEach((button) => {
          button.addEventListener('click', (evt) => this.handleBackInStockClick(evt));
        });
      });
  }

  replaceHtml(doc, selector) {
    const existingNode = this.querySelector(selector);
    const newNode = doc.querySelector(selector);

    if (existingNode != null) { 
      if (newNode) {
        existingNode.outerHTML = newNode.outerHTML;
      }
      else {
        existingNode.remove();
      }
    }
  }

  registerEvents() {
    this.querySelector('.product__submit__buttons .product__submit__add')
      .addEventListener('click', (evt) => this.handleCartButtonClick(evt));

    this.querySelectorAll('.quantity-selector .quantity__minus').forEach((button) => {
      button.addEventListener('click', (evt) => this.handleQuantityMinusClick(evt));
    });

    this.querySelectorAll('.quantity-selector .quantity__plus').forEach((button) => {
      button.addEventListener('click', (evt) => this.handleQuantityPlusClick(evt));
    });

    this.querySelectorAll('.select-popout__list li .select-popout__option-bis').forEach((button) => {
      button.addEventListener('click', (evt) => this.handleBackInStockClick(evt));
    });

    this.querySelectorAll('.list-swatches > li').forEach((swatch) => {
      swatch.addEventListener('click', (evt) => this.handleColorSwatchClick(evt));
    });

    document.querySelector('.cart-bar .product__submit__add')
     .addEventListener('click', (evt) => this.handleCartBarButtonClick(evt));
  }

  handleUpdate() {
    const cartButton = this.querySelector('.product__submit__buttons .product__submit__add');
    const cartBar = document.querySelector('.cart-bar');
    const cartBarPriceNode = cartBar.querySelector('.product__price span[data-product-price]');
    const cartBarButtonNode = cartBar.querySelector('.product__submit__add');

    const nowPriceNode = this.querySelector('.product__price span[data-product-price]');
    let beforePriceNode = this.querySelector('.product__price--strike');
    const pricePctNode = this.querySelector('.product__price--off');

    if (this.selected.duvet || this.selected.pillowcase) {
      cartButton.removeAttribute('disabled');
      cartBarButtonNode.removeAttribute('disabled');

      let sumPrice = 0;
      let totalComparePrice = 0;

      if (this.selected.duvet) {
        const duvetQuantity = this.querySelector('.product__selectors-duvet .selector-wrapper--quantity input')?.value ?? 1;
        sumPrice += this.selected.duvet.price * duvetQuantity;
        totalComparePrice += (this.selected.duvet.compare_at_price || this.selected.duvet.price) * duvetQuantity;
      }
      if (this.selected.pillowcase) {
        const pillowQuantity = this.querySelector('.product__selectors-pillow .selector-wrapper--quantity input')?.value ?? 1;
        sumPrice += this.selected.pillowcase.price * pillowQuantity;
        totalComparePrice += (this.selected.pillowcase.compare_at_price || this.selected.pillowcase.price) * pillowQuantity;
      }

      this.priceNode.innerHTML = `${Shopify.formatMoney(sumPrice, window.theme.moneyWithoutCurrencyFormat)}`;
      cartBarPriceNode.innerHTML = this.priceNode.innerHTML;

      const isOnSale = this.selected.duvet?.isOnSale || this.selected.pillowcase?.isOnSale;

      if (isOnSale) {
        if (nowPriceNode) {
          nowPriceNode.classList.add('product__price--sale');
        }

        if (!beforePriceNode) { 
          // Create a new span with class ".product__price--strike" and add it to the ".product__price" element
          beforePriceNode = document.createElement('span');
          beforePriceNode.classList.add('product__price--strike');
          beforePriceNode.setAttribute('data-compare-price', '');
          this.querySelector('.product__price').appendChild(beforePriceNode);
        }

        if (beforePriceNode) {
          beforePriceNode.style.display = 'inline-block';
          const comparePriceElement = this.querySelector('.product__price--strike[data-compare-price]');
          comparePriceElement.innerHTML = `${Shopify.formatMoney(totalComparePrice, window.theme.moneyWithoutCurrencyFormat)}`;

          const discountPercentage = ((totalComparePrice - sumPrice) / totalComparePrice) * 100;
          const roundedDiscountPercentage = Math.round(discountPercentage);
          pricePctNode.innerHTML = `${roundedDiscountPercentage}% rabat`;
        }

        if (pricePctNode) {
          pricePctNode.classList.remove('hide');
        }
      } else {
        if (nowPriceNode) {
          nowPriceNode.classList.remove('product__price--sale');
        }

        if (beforePriceNode) {
          beforePriceNode.style.display = 'none';
        }

        if (pricePctNode) {
          pricePctNode.classList.add('hide');
        }
      }
    } else {
      cartButton.setAttribute('disabled', true);
      cartBarButtonNode.setAttribute('disabled', true);
      const products = [...this.duvetsSameColor, ...this.pillowcases];

      if (products.length > 0) {
        const cheapestProduct = products.reduce((prev, current) => (prev.price < current.price) ? prev : current);
        this.priceNode.innerHTML = `Fra ${cheapestProduct.price_money}`; 
        cartBarPriceNode.innerHTML = this.priceNode.innerHTML;

        if (nowPriceNode) {
          nowPriceNode.classList.remove('product__price--sale');
        }

        if(beforePriceNode) {
          beforePriceNode.style.display = 'none';
        }

        if (pricePctNode) {
          pricePctNode.classList.add('hide');
        }
      }
    }

    this.querySelector('.product__price__wrap').style.display = 'block';

    if (this.selected.duvet?.isPreorder == "true" || this.selected.pillowcase?.isPreorder == "true") {
      // this.querySelector('.product__price__wrap').style.display = 'none';
      this.querySelector('.product__submit__buttons .product__submit__add').innerHTML = 'Forudbestil';
      this.querySelector('.product__submit__buttons .product__submit__add').classList.add('preorder');
      this.querySelector('.preorder-info').classList.remove('hidden');

      const shippingDate = this.selected.duvet?.preorderShippingDate ?? this.selected.pillowcase?.preorderShippingDate;
      const date = new Date(shippingDate);
      const options = { day: '2-digit', month: '2-digit', year: 'numeric'}
      const formattedDate = date.toLocaleDateString('da-DK', options);
      this.querySelector(".preorder-shipping-date").innerHTML = formattedDate;
    }
    else {
      this.querySelector('.product__submit__buttons .product__submit__add').innerHTML = 'Tilføj til kurv';
      this.querySelector('.product__submit__buttons .product__submit__add').classList.remove('preorder');
      this.querySelector('.preorder-info').classList.add('hidden');
    }
  }
}

customElements.define("main-product", MainProduct);

const selectors$t = {
  addButtonWrapper: '[data-add-action-wrapper]',
  animation: '[data-animation]',
  apiContent: '[data-api-content]',
  buttonQuickAdd: '[data-quick-add-btn]',
  buttonQuickAddMobile: '[data-quick-add-btn-mobile]',
  cartDrawer: '[data-cart-drawer]',
  cartLineItems: '[data-line-items]',
  focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
  media: '[data-media-slide]',
  messageError: '[data-message-error]',
  modalContainer: '[data-product-upsell-container]',
  modalContent: '[data-product-upsell-ajax]',
  productGridItem: 'data-product-grid-item',
  productInformationHolder: '[data-product-information]',
  popoutWrapper: '[data-popout]',
  quickAddHolder: 'data-quick-add-holder',
  quickAddModal: '[data-quick-add-modal]',
  quickAddModalTemplate: '[data-quick-add-modal-template]',
  quickAddVariant: 'data-quick-add-variant',
  quickAddProp: 'data-quick-add-props',
  siblingSwapper: 'data-sibling-swapper',
  swatch: '[data-swatch]',
  tooltip: '[data-tooltip]',
};

const selectors$T = {
  quantityHolder: '[data-quantity-holder]',
  quantityField: '[data-quantity-field]',
  quantityButton: '[data-quantity-button]',
  quantityMinusButton: '[data-quantity-minus]',
  quantityPlusButton: '[data-quantity-plus]',
  quantityReadOnly: 'read-only',
  isDisabled: 'is-disabled',
};
  
const selectors$i = {
  body: 'body',
  popdownTrigger: 'data-popdown-toggle',
  close: '[data-popdown-close]',
  input: '[data-predictive-search-input]',
};

const selectors$I = {
  popoutWrapper: '[data-popout]',
  popoutList: '[data-popout-list]',
  popoutToggle: '[data-popout-toggle]',
  popoutToggleText: '[data-popout-toggle-text]',
  popoutInput: '[data-popout-input]',
  popoutOptions: '[data-popout-option]',
  popoutPrevent: 'data-popout-prevent',
  popoutQuantity: 'data-quantity-field',
  dataValue: 'data-value',
  ariaExpanded: 'aria-expanded',
  ariaCurrent: 'aria-current',
  productGridImage: '[data-product-image]',
  productGrid: '[data-product-grid-item]',
};
  
const classes$z = {
  listVisible: 'popout-list--visible',
  visible: 'is-visible',
  active: 'is-active',
};

class QuantityCounter {
  constructor(holder, inCart = false) {
    this.holder = holder;
    this.quantityUpdateCart = inCart;
  }

  init() {
    // Settings
    this.settings = selectors$T;

    // DOM Elements
    this.quantity = this.holder.querySelector(this.settings.quantityHolder);

    if (!this.quantity) {
      return;
    }

    this.field = this.quantity.querySelector(this.settings.quantityField);
    this.buttons = this.quantity.querySelectorAll(this.settings.quantityButton);
    this.increaseButton = this.quantity.querySelector(this.settings.quantityPlusButton);

    // Set value or classes
    this.quantityValue = Number(this.field.value || 0);
    this.cartItemID = this.field.getAttribute('data-id');
    this.maxValue = Number(this.field.getAttribute('max')) > 0 ? Number(this.field.getAttribute('max')) : null;
    this.minValue = Number(this.field.getAttribute('min')) > 0 ? Number(this.field.getAttribute('min')) : 0;
    this.disableIncrease = this.disableIncrease.bind(this);

    // Flags
    this.emptyField = false;

    // Methods
    this.updateQuantity = this.updateQuantity.bind(this);
    this.decrease = this.decrease.bind(this);
    this.increase = this.increase.bind(this);

    this.disableIncrease();

    // Events
    if (!this.quantity.classList.contains(this.settings.quantityReadOnly)) {
      this.changeValueOnClick();
      this.changeValueOnInput();
    }
  }

  /**
   * Change field value when click on quantity buttons
   *
   * @return  {Void}
   */

  changeValueOnClick() {
    const that = this;

    this.buttons.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        const clickedElement = event.target;
        const isDescrease = clickedElement.matches(that.settings.quantityMinusButton) || clickedElement.closest(that.settings.quantityMinusButton);
        const isIncrease = clickedElement.matches(that.settings.quantityPlusButton) || clickedElement.closest(that.settings.quantityPlusButton);

        if (isDescrease) {
          that.decrease();
        }

        if (isIncrease) {
          that.increase();
        }

        that.updateQuantity();
      });
    });
  }

  /**
   * Change field value when input new value in a field
   *
   * @return  {Void}
   */

  changeValueOnInput() {
    this.field.addEventListener('change', () => {
      this.quantityValue = this.field.value;

      if (this.field.value === '') {
        this.emptyField = true;
      }

      this.updateQuantity();
    });
  }

  /**
   * Update field value
   *
   * @return  {Void}
   */

  updateQuantity() {
    if (this.maxValue < this.quantityValue && this.maxValue !== null) {
      this.quantityValue = this.maxValue;
    }

    if (this.minValue > this.quantityValue) {
      this.quantityValue = this.minValue;
    }

    this.field.value = this.quantityValue;

    this.disableIncrease();

    if (this.quantityUpdateCart) {
      this.updateCart();
    }
  }

  /**
   * Decrease value
   *
   * @return  {Void}
   */

  decrease() {
    if (this.quantityValue > this.minValue) {
      this.quantityValue--;

      return;
    }

    this.quantityValue = 0;
  }

  /**
   * Increase value
   *
   * @return  {Void}
   */

  increase() {
    this.quantityValue++;
  }

  /**
   * Disable increase
   *
   * @return  {[type]}  [return description]
   */

  disableIncrease() {
    this.increaseButton.classList.toggle(this.settings.isDisabled, this.quantityValue >= this.maxValue && this.maxValue !== null);
  }

  /**
   * Update cart
   *
   * @return  {Void}
   */

  updateCart() {
    const event = new CustomEvent('theme:cart:update', {
      bubbles: true,
      detail: {
        id: this.cartItemID,
        quantity: this.quantityValue,
        valueIsEmpty: this.emptyField,
      },
    });

    this.holder.dispatchEvent(event);
  }
}
